import React, { Fragment, useEffect, useState, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import NoPermission from "../../common/NoPermission";
import { useDispatch, useSelector } from "react-redux";
import LoaderSpinner from "../../common/LoaderSpinner";
import FileUpload from "../../common/FileUpload";
import {
  getStudentProfileForUpdateOnly,
  getStudentProfileByFormNumber,
  getPayableFeeForStudent,
  savePaymentRecords,
  resetStudentProfile
} from "../../api/admissionApi";
import { uploadSingleFileToS3 } from "../../api/fileUploadApi";
import RegistrationInfo from "./RegistrationInfo";
import { makeStyles } from "@mui/styles";


const useStyles = makeStyles((theme) => ({
  denominationParent :{
    display: "flex",
    flexDirection: "row",
    columnGap: "8px", 
    marginBottom: "0px"
  },
  denoInput: {
    width: "40%", 
    height: "75%",
    marginLeft: "5%"
  },
  denoTitle: {
    width: "3%"
  }
}));
function RecordPayments({ permissions = {}, isSuperAdmin }) {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const {
    authenticationReducer: {
      isStudent,
      faculty_id
    } = {},
    admissionReducer: {
      isAdmissionsOpen = false,
      admissionPageInfo = {},
      isFetchingExistingAdmsnPageInfo = false,
      isUserProfileLoading = false,
      isAdmissionPageInfoLoaded = false,
      admissionPageInfoFailed,
      studentProfile = {}
    }
  } = state;

  const fileUploadRef = useRef(null);
  const classes = useStyles();
  const [searchByFormNumber, setSearchByFormNumber] = useState("");
  const [searchByEmail, setSearchByEmail] = useState("");
  const [isStudentProfileFetched, setIsStudentProfileFetched] = useState(false);
  const [showStudentFullProfile, setShowStudentFullProfile] = useState(false);
  const [paymentConfirmationDocument, setPaymentConfirmationDocument] = useState("");
  const [payableFees, setPayableFees] = useState(0);
  const [payment_mode, setPaymentMode] = useState('demandDraft');
  const [userPaymentInfo, setUserPaymentInfo] = useState({
    "isPaymentVerified": false,
    "transaction_number": "",
    "payment_mode": "",
    "payment_doc_url": "",
    "documents_verified": false,
    "verified_by": faculty_id,
    "formNumber": "",
    "total_fee_paid": "",
    "denominations": []
  });

  const getStudProfileByEmail = (email, cbs) => dispatch(getStudentProfileForUpdateOnly(email, cbs));
  const getStudProfileByFormNo = (formNumber, cbs) => dispatch(getStudentProfileByFormNumber(formNumber, cbs));
  const getPayableFee = (email, cbs) => dispatch(getPayableFeeForStudent({ email_id: email }, cbs));
  const savePaymentUpdatedRecords = (data, cbs) => dispatch(savePaymentRecords(data, cbs));
  const resetStuProfile = () => dispatch(resetStudentProfile());
  const [denominations, setDenominations] = useState({
    "2000": 0,
    "500": 0,
    "200": 0,
    "100": 0,
    "50": 0,
    "20": 0,
    "10": 0,
    "5": 0,
    "2": 0,
    "1": 0
  });

  useEffect(() => {
    if (showStudentFullProfile) {
      document.body.classList.add('disable-scroll');
    } else {
      document.body.classList.remove('disable-scroll');
    }
  }, [showStudentFullProfile]);

  const cashDenominationsTotal = 2000*denominations["2000"] + 500*denominations["500"] + 200*denominations["200"] + 100*denominations["100"] + 50*denominations["50"] + 20*denominations["20"] + 10*denominations["10"] + 5*denominations["5"] + 2*denominations["2"] + 1*denominations["1"];

  const {entranceRollNumber, payment_status: {isPaymentVerified, documents_verified, transaction_number = '', payment_mode: paymentMode = '', payment_doc_url = '', total_fee_paid: totalFeePaid = "", cash_denominations } = {}} = studentProfile;


  const renderHeader = () => {
    return (
      <Fragment>
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">Record payments</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <span>St. Andrews College</span>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Record payments
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  const fetchStudentInfo = () => {
    const callbacks = {
      successCallback: getStudentProfileSuccessCallback,
      failureCallback: getStudentProfileFailureCallback,
    };
    if (!isStudent && searchByFormNumber)
      getStudProfileByFormNo(searchByFormNumber, callbacks);
    else if (!isStudent && searchByEmail)
      getStudProfileByEmail(searchByEmail, callbacks);
    else toast.error("You are not permitted to search student profile.");
  };

  const getStudentProfileSuccessCallback = (data = {}) => {
    const {status, profileDetails: {email_id = ''} = {}} = data;
    if(studentProfile.is_registration_completed)toast.success("Student profile fetched successfully.");
    else toast.success("Data fetched.");
    if (status) {
      setIsStudentProfileFetched(true);
      if(data.profileDetails.payment_status) {
        if(studentProfile.is_registration_completed)toast.success("Previous data loaded.")
        setUserPaymentInfo({...data.profileDetails.payment_status});
      } 
      getPayableFee(email_id, {
        successCallback: (response) => {
          setPayableFees(response.feeToBePaid);
          //assuming student is paying complete fees, if separate records needs to be maintainted, update the below line
          setUserPaymentInfo({...userPaymentInfo, total_fee_paid: response.feeToBePaid});
        },
        failureCallback: (errData) => {
          setPayableFees(0);
          toast.error("Couldn't fetch the payable fees for this account.")
        },
      });
    }
  };

  const getStudentProfileFailureCallback = (errData) => {
    setIsStudentProfileFetched(false);
    if(errData.data.registrations === "No registrations found with provided filters")  toast.error(errData.data.registrations);
    if (errData !== undefined && errData.data) toast.error(errData.data.err);
    // MOMENT WHEN WRONG INPUT IS PASSED OR SOME OTHER TECHNICAL ERROR OCCURED
    else alert("Error with your network, please try again!");
  };

  const resetAll = () => {
    setIsStudentProfileFetched(false);
    setPayableFees(0);
    resetStuProfile();
    setPaymentConfirmationDocument("");
    setShowStudentFullProfile(false);
    setUserPaymentInfo({
      "isPaymentVerified": false,
      "transaction_number": "",
      "payment_mode": "",
      "payment_doc_url": "",
      "documents_verified": false,
      "verified_by":faculty_id,
      "formNumber": "",
      "total_fee_paid": ""
    })
  }

  const renderStudentSearchFilters = () => {
    return (
      <Fragment>
        <div className="d-flex mb-4 align-items-center">
          Enter Form/Registration Number:
          <input
            type="number"
            className="form-control w-25 ml-3"
            placeholder="Form no./Reg. no"
            value={searchByFormNumber}
            onChange={(e) => {
              setSearchByEmail("");
              setSearchByFormNumber(e.target.value);
              resetAll();
            }}
            onKeyUp={(e) => {
              e.keyCode === 13 && fetchStudentInfo();
            }}
          />
        </div>
        <p>-- OR --</p>
        <div className="d-flex mb-4 align-items-center">
          Enter Student's email:
          <input
            type="email"
            className="form-control w-25 ml-3"
            placeholder="Email id"
            value={searchByEmail}
            onChange={(e) => {
              setSearchByFormNumber("");
              setSearchByEmail(e.target.value);
              resetAll();
            }}
            onKeyUp={(e) => {
              e.keyCode === 13 && fetchStudentInfo();
            }}
          />
        </div>
        <div className="d-flex align-items-center mt-3">
          <button
            className="btn btn-primary"
            type="button"
            disabled={
              isUserProfileLoading || (!searchByFormNumber && !searchByEmail)
            }
            onClick={fetchStudentInfo}
          >
            {isUserProfileLoading ? <LoaderSpinner /> : "Search student"}
          </button>
        </div>
      </Fragment>
    );
  };

  const updateFileUploadStatus = (newFiles, fieldName, uploadStatusObj) => {
    uploadStatusObj.uploading();
    if (newFiles) {
      const callbacks = {
        successCallback: fileUploadSuccessCallback,
        failureCallback: fileUploadFailureCallback,
      };
      dispatch(
        uploadSingleFileToS3(newFiles, fieldName, callbacks, uploadStatusObj)
      );
    }
  };

  const fileUploadSuccessCallback = (resp, fieldName, uploadStatusObj) => {
    const { link = "", fileCategory = "" } = resp;
    // setPaymentConfirmationDocument(link);
    setUserPaymentInfo({...userPaymentInfo, payment_doc_url: link});
    uploadStatusObj.uploadSuccess();
  };
  const fileUploadFailureCallback = (resp, uploadStatusObj) => {
    uploadStatusObj.uploadFailure();
  };

  const savePaymentUpdates = () => {
    const callbacks = {
      successCallback: updatePaymentRecordsSuccessCallback,
      failureCallback: updatePaymentRecordsFailureCallback,
    };
    let requestParam = {...userPaymentInfo};
    requestParam.formNumber = studentProfile.formNumber;
    requestParam.denominations = {...denominations};
    savePaymentUpdatedRecords(requestParam, callbacks);
  }
  const updatePaymentRecordsSuccessCallback = (data = {}) => {
    if(data.status) toast.success(data.message);
    resetAll();
    setSearchByFormNumber("");
    setSearchByEmail("");
  }
  const updatePaymentRecordsFailureCallback = (errData) => {
    toast.error(errData.err);
  }

  const renderPaymentStatusBody = () => {
    return (
      <Fragment>
        <div className="ml-4">
          <div className="d-flex mb-4 align-items-center">
            1. Payment received<span style={{ color: "red" }}>*</span>:
            <input
              type="checkbox"
              className="form-control w-10 ml-3 no-outline"
              disabled={payableFees <= 0 || isPaymentVerified}
              checked={userPaymentInfo.isPaymentVerified || isPaymentVerified}
              onChange={(e) => {
                if(e.target.value === "on" && userPaymentInfo.isPaymentVerified) 
                  setUserPaymentInfo({...userPaymentInfo, isPaymentVerified: false})
                else
                  setUserPaymentInfo({...userPaymentInfo, isPaymentVerified: e.target.value === "on" && true})
                // setSearchByFormNumber("");
                // setSearchByEmail(e.target.value);
              }}
            />{" "}
            <p className="text-danger" style={{margin: '0px'}}>
              {isStudentProfileFetched && payableFees > 0
                ? `As per the databases the amount to be received is: Rs. ${payableFees}`
                : "No payable amount calculated/found in database yet!"}
            </p>
          </div>
          <div className="d-flex mb-4 align-items-center">
            2. Transaction number<span style={{ color: "red" }}>*</span>:
            <input
              type="text"
              className="form-control w-25 ml-3"
              placeholder="Transaction number"
              disabled={payableFees <= 0 || transaction_number !== '' || userPaymentInfo.payment_mode === "cash"}
              value={userPaymentInfo.transaction_number || transaction_number}
              onChange={(e)=> setUserPaymentInfo({...userPaymentInfo, transaction_number: e.target.value})}
            />
          </div>

          <div className="d-flex mb-2 align-items-center">
            3. Payment mode<span style={{ color: "red" }}>*</span>:
            <div
              className="col-md-2 col-sm-12"
              style={{
                display: "flex",
                placeContent: "center",
                alignItems: "baseline",
                outline: "none"
              }}
            >
              <input
                type="radio"
                name="demandDraft"
                className="form-control w-10 ml-3 no-outline"
                value="dd"
                onChange={() => setUserPaymentInfo({...userPaymentInfo, payment_mode: 'demandDraft'})}
                checked={userPaymentInfo.payment_mode === 'demandDraft' || paymentMode === 'demandDraft'}
                disabled={paymentMode !== ''}
              />
              <label>Cheque/DD</label>
            </div>
            <div
              className="col-md-2 col-sm-12"
              style={{
                display: "flex",
                placeContent: "center",
                alignItems: "baseline",
                outline: "none"
              }}
            >
              <input
                type="radio"
                name="posMethod"
                className="form-control w-10 ml-3 no-outline"
                value="pos"
                onChange={() => setUserPaymentInfo({...userPaymentInfo, payment_mode: 'posMach'})}
                checked={userPaymentInfo.payment_mode === 'posMach' || paymentMode === 'posMach'}
                disabled={paymentMode !== ''}
              />
              <label>POS machine</label>
            </div>
            {/* <div
              className="col-md-2 col-sm-12"
              style={{
                display: "flex",
                placeContent: "center",
                alignItems: "baseline",
                outline: "none"
              }}
            >
              <input
                type="radio"
                name="onlineMethod"
                className="form-control w-10 ml-3 no-outline"
                value="online"
                onChange={() => setUserPaymentInfo({...userPaymentInfo, payment_mode: 'onlineMethod'})}
                checked={userPaymentInfo.payment_mode === 'onlineMethod' || paymentMode === 'onlineMethod'}
                disabled={paymentMode !== ''}
              />
              <label>Online/Card</label>
            </div> */}
            <div
              className="col-md-2 col-sm-12"
              style={{
                display: "flex",
                placeContent: "center",
                alignItems: "baseline",
                outline: "none"
              }}
            >
              <input
                type="radio"
                name="cashMethod"
                className="form-control w-10 ml-3 no-outline"
                value="cash"
                onChange={() => setUserPaymentInfo({...userPaymentInfo, payment_mode: 'cash', transaction_number: ""})}
                checked={userPaymentInfo.payment_mode === 'cash' || paymentMode === 'cash'}
                disabled={paymentMode !== ''}
              />
              <label>Cash</label>
            </div>
          </div>
          {userPaymentInfo.payment_mode === "cash" && (<div className="ml-15 mt-0 mb-2">
              <p style={{ textDecoration: "underline" }} className="mb-2">
                DENOMINATIONS<span style={{ color: "red" }}>*</span>:
              </p>
            <p className={classes.denominationParent}><div className={classes.denoTitle}>2000</div> x 
              <span>
                <input type="number" className={`form-control ${classes.denoInput}`} value={denominations["2000"]} onChange={(e)=> setDenominations({...denominations, "2000": Number(e.target.value)})}/>
              </span>
            </p>
            <p className={classes.denominationParent}><div className={classes.denoTitle}>500</div> x
              <span>
                <input type="number" className={`form-control ${classes.denoInput}`} value={denominations["500"]} onChange={(e)=> setDenominations({...denominations, "500": Number(e.target.value)})}/>
              </span>
            </p>
            <p className={classes.denominationParent}><div className={classes.denoTitle}>200</div> x
              <span>
                <input type="number" className={`form-control ${classes.denoInput}`} value={denominations["200"]} onChange={(e)=> setDenominations({...denominations, "200": Number(e.target.value)})}/>
              </span>
            </p>
            <p className={classes.denominationParent}><div className={classes.denoTitle}>100</div> x
              <span>
                <input type="number" className={`form-control ${classes.denoInput}`} value={denominations["100"]} onChange={(e)=> setDenominations({...denominations, "100": Number(e.target.value)})}/>
              </span>
            </p>
            <p className={classes.denominationParent}><div className={classes.denoTitle}>50</div> x
              <span>
                <input type="number" className={`form-control ${classes.denoInput}`} value={denominations["50"]} onChange={(e)=> setDenominations({...denominations, "50": Number(e.target.value)})}/>
              </span>
            </p>
            <p className={classes.denominationParent}><div className={classes.denoTitle}>20</div> x
              <span>
                <input type="number" className={`form-control ${classes.denoInput}`} value={denominations["20"]} onChange={(e)=> setDenominations({...denominations, "20": Number(e.target.value)})}/>
              </span>
            </p>
            <p className={classes.denominationParent}><div className={classes.denoTitle}>10</div> x
              <span>
                <input type="number" className={`form-control ${classes.denoInput}`} value={denominations["10"]} onChange={(e)=> setDenominations({...denominations, "10": Number(e.target.value)})}/>
              </span>
            </p>
            <p className={classes.denominationParent}><div className={classes.denoTitle}>5</div> x
              <span>
                <input type="number" className={`form-control ${classes.denoInput}`} value={denominations["5"]} onChange={(e)=> setDenominations({...denominations, "5": Number(e.target.value)})}/>
              </span>
            </p>
            <p className={classes.denominationParent}><div className={classes.denoTitle}>2</div> x
              <span>
                <input type="number" className={`form-control ${classes.denoInput}`} value={denominations["2"]} onChange={(e)=> setDenominations({...denominations, "2": Number(e.target.value)})}/>
              </span>
            </p>
            <p className={classes.denominationParent}><div className={classes.denoTitle}>1</div> x
              <span>
                <input type="number" className={`form-control ${classes.denoInput}`} value={denominations["1"]} onChange={(e)=> setDenominations({...denominations, "1": Number(e.target.value)})}/>
              </span>
            </p>
            <p>Total = &#8377; {cashDenominationsTotal}&nbsp; &nbsp;
            {cashDenominationsTotal > payableFees ? <span className="text-danger">(Note: Can't be more than the applicable amount!)</span> : cashDenominationsTotal < 0 ?  <span className="text-danger">(Note: Amount can't be negative!)</span> : ""}</p>
          </div>)}
          <div className="d-flex mb-4 align-items-center">
            4. Payment document (if Any):
            <div className="ml-25">
              <FileUpload
                isDisabled={Boolean(payableFees <= 0) || payment_doc_url || isPaymentVerified}
                fileUploadRef={fileUploadRef}
                fieldName="userPaymentInfo.payment_doc_url"
                // setParentField={setPaymentConfirmationDocument}
                setSelectedFiles={setPaymentConfirmationDocument}
                selectedFiles={userPaymentInfo.payment_doc_url}
                // formik={formik}
                fileUploadStatus={updateFileUploadStatus}
                uploadedFileUrl={payment_doc_url}
              />
            </div>
          </div>
        </div>
      </Fragment>
    );
  };
  const renderDocumentStatusBody = () => {
    return (
      <Fragment>
        <div className="ml-4">
          <div className="d-flex mb-4 align-items-center">
            1. All documents verified?<span style={{ color: "red" }}>*</span>
            <input 
              type="checkbox" 
              className="form-control w-10 ml-3 no-outline" 
              checked={userPaymentInfo.documents_verified || documents_verified}
              onChange={(e) => {
                if(e.target.value === "on" && userPaymentInfo.documents_verified) 
                  setUserPaymentInfo({...userPaymentInfo, documents_verified: false})
                else
                  setUserPaymentInfo({...userPaymentInfo, documents_verified: e.target.value === "on" && true})
              }}
              disabled={documents_verified}
            />
          </div>
        </div>
      </Fragment>
    );
  };

  const renderStudentProfileFetchedBody = () => {
    const submitBtnDisableCond = !userPaymentInfo.isPaymentVerified || (userPaymentInfo.payment_mode !== "cash" && userPaymentInfo.transaction_number === "") || (userPaymentInfo.payment_mode === "cash" && cashDenominationsTotal !== payableFees) || !userPaymentInfo.documents_verified;
    return (
      <Fragment>
        {isStudentProfileFetched && (
          <Fragment>
            {/* START: YET TO BE RESOLVES, NOT RE-RENDERING ON CHANGE */}

            <div
              className="mt-4"
              style={{
                display: "flex",
                alignItems: "baseline",
              }}
            >
              <p style={{ textDecoration: "underline" }} className="mb-0">
                Registration status:{" "}
              </p>
              <span
                className="ml-2"
                style={
                  studentProfile.is_registration_completed
                    ? { background: "greenyellow" }
                    : { background: "#ffff00b5" }
                }
              >
                {studentProfile.is_registration_completed
                  ? " Complete"
                  : !studentProfile.is_registration_completed
                  ? " Incomplete"
                  : ""}
              </span>
            </div>
            <div
              className="mt-4"
              style={{
                display: "flex",
                alignItems: "baseline",
              }}
            >
              <p style={{ textDecoration: "underline" }} className="mb-0">
                Form number:
              </p>
              <span 
              style={
                studentProfile.formNumber
                  ? { background: "greenyellow" }
                  : { background: "#ffff00b5" }
              }
              className="ml-2">{studentProfile.formNumber ? studentProfile.formNumber : "Not generated as registration is incomplete."}</span>
            </div>
            <div
              className="mt-4"
              style={{
                display: "flex",
                alignItems: "baseline",
              }}
            >
              <p style={{ textDecoration: "underline" }} className="mb-0">
                Entrance roll number:
              </p>
              <span 
              style={
                entranceRollNumber
                  ? { background: "greenyellow" }
                  : { background: "#ffff00b5" }
              }
              className="ml-2">{entranceRollNumber ? entranceRollNumber : "Not generated as college fees payment verification is incomplete."}</span>
            </div>

            {/* END: YET TO BE RESOLVES, NOT RE-RENDERING ON CHANGE */}

            {studentProfile.is_registration_completed && (
              <Fragment>
                <div className="mt-4">
                  <p
                    className="text-primary"
                    onClick={() => setShowStudentFullProfile(true)}
                    style={{ cursor: "pointer" }}
                  >
                    Show full profile
                  </p>
                </div>

                <hr className="section-hr" />
                <p style={{ fontWeight: "bold" }}>Update payment status:</p>
                {renderPaymentStatusBody()}
                <hr className="section-hr" />
                <p style={{ fontWeight: "bold" }}>Update document status:</p>
                {renderDocumentStatusBody()}
                <hr className="section-hr" />
                <div className="d-flex align-items-center mt-3">
                  <button
                    className="btn btn-primary mr-2"
                    type="button"
                    // disabled={
                    //   isUserProfileLoading ||
                    //   (!searchByFormNumber && !searchByEmail)
                    // }
                    onClick={() => savePaymentUpdates()}
                    // disabled={payment_doc_url && isPaymentVerified && paymentMode && documents_verified && transaction_number}
                    disabled={submitBtnDisableCond}
                  >
                    {/* {isUserProfileLoading ? <LoaderSpinner /> : "Search student"} */}
                    Submit
                  </button>
                  {payment_doc_url && isPaymentVerified && paymentMode && documents_verified && transaction_number && <p className="m-0"><i>{`(Payment status is updated)`}</i></p>}
              </div>
              </Fragment>
            )}
          </Fragment>
        )}
      </Fragment>
    );
  };

  const renderContent = () => {
    return (
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Update payment records for student's course fees</h3>
        </div>

        <div className="card-body">
          {renderStudentSearchFilters()}
          {renderStudentProfileFetchedBody()}
        </div>
      </div>
    );
  };

  if (!isSuperAdmin && !permissions.read) {
    return <NoPermission />;
  }

  const handleClose = () => {
    setShowStudentFullProfile(false);
  };

  return (
    <Fragment>
      {renderHeader()}
      <div className="section-body mt-4">
        <div className="container-fluid">{renderContent()}</div>
      </div>
      <ToastContainer />
      {showStudentFullProfile && (
        <RegistrationInfo
          selectedReg={studentProfile}
          showRegInfo={showStudentFullProfile}
          handleClose={handleClose}
        />
      )}
    </Fragment>
  );
}

export default RecordPayments;
